import QRCode from 'qrcode'

/**
 * 認証アプリへ読ませる QR コードを、<b>端末の中だけで</b>描く。
 *
 * <p>ログイン画面の「2要素の登録」パネルと、セキュリティ設定の2要素認証の
 * 両方で使う（人の目の洗い出し 束22、2026-09-30）。以前はセキュリティ設定に
 * しか無く、会社が必須にして登録させられる入口（ログイン画面）のほうが
 * 32文字を手で打つしかなかった。</p>
 *
 * <h3>外へ出さない</h3>
 *
 * <p><b>QR画像を作るサービスへ渡してはいけない。</b>otpauth:// には
 * 2要素の共有鍵がそのまま入っている。渡した先は、その人の6桁を
 * いつでも作れる。</p>
 *
 * <h3>SVG で描く</h3>
 *
 * <p>拡大しても粗くならない（印刷して配る会社がある）。canvas が無い場所でも
 * 動く（検査は jsdom で走る。canvas が無いと toDataURL が落ち、<b>QR が
 * 出ないことに気づけないまま緑になる</b>）。</p>
 *
 * <h3>作れなくても止めない</h3>
 *
 * <p>QR が出なくても、鍵を手で入れれば登録できる。ここで例外を投げると
 * <b>登録そのものが始められなくなる。</b>作れなければ空文字を返す。</p>
 *
 * @param {string} otpauthUri サーバが返した otpauth://
 * @returns {Promise<string>} data: の画像。作れなければ ''
 */
export async function otpauthQrDataUrl (otpauthUri) {
  const uri = typeof otpauthUri === 'string' ? otpauthUri : ''
  if (!uri) return ''
  try {
    const svg = await QRCode.toString(uri, {
      type: 'svg',
      width: 200,
      margin: 1,
      errorCorrectionLevel: 'M'
    })
    return 'data:image/svg+xml;base64,' + toBase64(svg)
  } catch (error) {
    return ''
  }
}

/** SVG を data: へ入れる形にする。 */
function toBase64 (text) {
  if (typeof window !== 'undefined' && window.btoa) {
    return window.btoa(unescape(encodeURIComponent(text)))
  }
  /* 検査の環境では window.btoa が無いことがある。 */
  return Buffer.from(text, 'utf8').toString('base64')
}
